export const getFileTypeIcon = (type) => {
  switch (type.toLowerCase()) {
    case "xls":
    case "xlsx":
      return "assets/illustrations/xlsfile.svg";
    case "pdf":
      return "assets/illustrations/pdffile.svg";
    case "docx":
    case "doc":
      return "assets/illustrations/docfile.svg";
    case "png":
    case "jpg":
    case "jpeg":
      return "assets/illustrations/image_png.png";
    case "txt":
      return "assets/illustrations/txt.png";
    default:
      return "assets/illustrations/image_png.png";
  }
};
